import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import drinkImg from "../../../assets/Drinks/drink1.jpg";
import lambImg from "../../../assets/Lunch/lunch2.jpg";
import wrapImg from "../../../assets/Dinner/dinner1.jpg";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const DiscoverPage = () => {
  return (
    <>
      <section className="py-24 px-4 bg-primary-50 overflow-hidden">
        <motion.div
          className="max-w-6xl mx-auto text-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ staggerChildren: 0.15 }}
        >
          <motion.h3
            variants={fadeUp}
            className="font-italianno text-4xl text-primary-800 mb-2"
          >
            Discover
          </motion.h3>

          <motion.h2
            variants={fadeUp}
            className="text-3xl md:text-4xl font-bold font-sans text-primary-800 tracking-wide"
          >
            NEW FLAVORS
          </motion.h2>

          <motion.div
            variants={fadeUp}
            className="flex flex-col items-center gap-1 mt-4 mb-8"
          >
            <span className="w-16 h-[1px] bg-primary-800" />
            <span className="w-16 h-[1px] bg-primary-800" />
          </motion.div>

          <motion.div
            variants={fadeUp}
            className="text-center text-left text-primary-700 text-xl leading-relaxed"
          >
            <p>
              The people,the food and the prime location make <b> Eelaa Cafe </b> the perfect place for good friends and family to come together and have a great time.Every time you dine with us,it should be for great inspired food in an environment designed with individual touches unique to the local area.
            </p>
          </motion.div>

          <motion.div variants={fadeUp}>
            <Link to="/about">
              <button className="mt-12 px-10 py-3 rounded-full bg-primary-800 border-2 border-primary-100 text-primary-100 font-medium hover:bg-primary-100 hover:text-primary-800 transition">
                More About Us
              </button>
            </Link>
          </motion.div>
        </motion.div>
      </section>

      {/* SPECIAL DISHES */}
      <section className="py-24 px-4 bg-background-soft">
        <motion.div
          className="max-w-7xl mx-auto text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ staggerChildren: 0.15 }}
        >
          <motion.h3
            variants={fadeUp}
            className="font-italianno text-4xl text-primary-800 mb-2"
          >
            Menu
          </motion.h3>

          <motion.h2
            variants={fadeUp}
            className="text-3xl md:text-4xl font-bold font-sans text-primary-800 tracking-wide"
          >
            SPECIAL DISHES
          </motion.h2>

          <motion.div
            variants={fadeUp}
            className="flex flex-col items-center gap-1 mt-4 mb-8"
          >
            <span className="w-16 h-[1px] bg-primary-800" />
            <span className="w-16 h-[1px] bg-primary-800" />
          </motion.div>

        </motion.div>

        {/* CARDS */}
        <div className="grid md:grid-cols-3 gap-10 max-w-7xl mx-auto">
          {[ 
            {
              img: drinkImg,
              tag: "DRINKS",
              title: "BASIL LEMONADE",
              price: "₹585",
              desc: "Basil Lemon Syrup, Cold Water, Ice Cubes",
              meta: "250g · 70cal · V · K · S",
            },
            {
              img: lambImg,
              tag: "LUNCH",
              title: "ROASTED LAMB",
              price: "₹870",
              desc: "Boneless Lamb Leg, Garlic, Onion, Spices, Rosemary",
              meta: "280g · 320cal",
            },
            {
              img: wrapImg,
              tag: "DINNER",
              title: "ASIAN CHICKEN WRAP",
              price: "₹99",
              desc: "Sliced Chicken, Broccoli Slaw, Mixed Greens",
              meta: "245g · 186cal · V",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              className="text-left"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -6 }}
            >
              <div className="relative w-full h-[220px] md:h-[260px] overflow-hidden rounded-md">
                <motion.img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.08 }}
                  transition={{ duration: 0.4 }}
                />
                <span className="absolute top-4 right-4 bg-background-soft text-xs px-3 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>

              <div className="mt-4 flex justify-between items-center">
                <h4 className="font-semibold">{item.title}</h4>
                <span className="font-medium">{item.price}</span>
              </div>

              <p className="text-xs text-primary-700 mt-1">{item.desc}</p>
              <p className="text-xs mt-2">{item.meta}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <Link to="/menu">
            <button className="px-10 py-3 rounded-full bg-primary-800 border-2 border-primary-100 text-primary-100 font-medium hover:bg-primary-100 hover:text-primary-800 transition">
              View Full Menu
            </button>
          </Link>
        </motion.div>
      </section>
    </>
  );
};

export default DiscoverPage;
